import { Rule } from 'antd/es/form';

export enum FORM_FIELD {
  CODE = 'code',
  NAME = 'name',
  DESCRIPTION = 'description',
  SOLAR_DAYS = 'solarDays',
  LUNAR_DAYS = 'lunarDays',
  START_FROM = 'startFrom',
  END_TO = 'endTo',
}

export const FormLabels: Partial<Record<FORM_FIELD, string>> = {
  [FORM_FIELD.NAME]: 'Tên',
  [FORM_FIELD.DESCRIPTION]: 'Mô tả',
  [FORM_FIELD.SOLAR_DAYS]: 'Ngày lễ Dương Lịch',
  [FORM_FIELD.LUNAR_DAYS]: 'Ngày lễ Âm Lịch',
  [FORM_FIELD.START_FROM]: 'Ngày bắt đầu',
  [FORM_FIELD.END_TO]: 'Ngày kết thúc',
};

export const FormValidations: Partial<Record<FORM_FIELD, Rule[]>> = {
  [FORM_FIELD.NAME]: [{ required: true, message: 'Hãy nhập tên cao điểm bán' }],
  [FORM_FIELD.START_FROM]: [
    { required: true, message: 'Hãy chọn ngày bắt đầu' },
  ],
  [FORM_FIELD.END_TO]: [{ required: true, message: 'Hãy chọn ngày kết thúc' }],
};
